import { PartnerApiResponse } from 'providers/offers/types';
import axiosInstance from 'src/axios-instance';
import { proxyUrl } from './utils';

const getPartnerPackage = (
  sessionId,
  compression,
  partner,
  timeout = 60000,
  source = 'offers',
  customProxy = ''
): any =>
  axiosInstance.post<string | PartnerApiResponse>(
    `${proxyUrl(customProxy)}${source}/partner`,
    {
      sessionId,
      compression: compression ? 'zip' : undefined,
      partner
    },
    { timeout }
  );

export default getPartnerPackage;
